'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = require('../../components');

var _validate = require('../../utils/validate');

var _ReportIssueForm = require('./ReportIssueForm.scss');var styles = _interopRequireWildcard(_ReportIssueForm);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // Helpers

var reqSign = '\u202A\xA0*\xA0'; // Styles
// Components
// Modules
var ReportIssueForm = function ReportIssueForm(props) {return _react2.default.createElement('div', { className: styles.reportIssuesForm },
    _react2.default.createElement('div', null, props.title),
    _react2.default.createElement('div', { className: styles.formRow },
      props.shouldRenderReason &&
      _react2.default.createElement(_components.OMInputField, {
        placeholder: '' + props.reasonPlaceholder + reqSign,
        name: 'reason',
        onBlur: props.handleChange,
        onChange: props.handleChange,
        validate: function validate(value) {return !!value;},
        isInvalid: props.fieldIsInvalid('reason') })),




    _react2.default.createElement('div', { className: styles.formRow },
      _react2.default.createElement(_components.OMInputField, {
        type: 'textarea',
        placeholder: '' + props.descriptionPlaceholder + (props.fieldIsRequired('issue') ? reqSign : ''),
        name: 'issue',
        onChange: props.handleChange,
        isInvalid: props.fieldIsInvalid('issue') })),



    _react2.default.createElement('div', { className: styles.formRow },
      _react2.default.createElement(_components.OMInputField, {
        placeholder: '' + props.emailPlaceholder + reqSign,
        name: 'email',
        onBlur: props.handleChange,
        onChange: props.handleChange,
        validate: _validate.emailRegexValidation,
        isInvalid: props.fieldIsInvalid('email') })),


    _react2.default.createElement(_components.GoogleReCaptcha, {
        locale: props.locale,
        fetchToken: props.fetchReCaptchaToken,
        doReset: props.showPreloader,
        captchaIdentifier: 'report' },

      _react2.default.createElement(_components.OMButtonWithPreloader, {
        innerText: props.submitButtonText,
        showPreloader: props.showPreloader,
        id: 'report-button' })));};





ReportIssueForm.propTypes = {
  title: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  fetchReCaptchaToken: _propTypes2.default.func,
  descriptionPlaceholder: _propTypes2.default.func,
  reasonPlaceholder: _propTypes2.default.func,
  emailPlaceholder: _propTypes2.default.func,
  submitButtonText: _propTypes2.default.func,
  fieldIsInvalid: _propTypes2.default.func,
  fieldIsRequired: _propTypes2.default.func,
  submitForm: _propTypes2.default.func,
  handleChange: _propTypes2.default.func,
  showPreloader: _propTypes2.default.bool,
  shouldRenderReason: _propTypes2.default.bool };exports.default =


ReportIssueForm;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ReportIssueForm/ReportIssueForm.js
// module id = 2903
// module chunks = 0